<template>
  <div v-if="can('assign-permission-to-role')">
    <h2>Assign Permission</h2>
    <div class="custom-form">
      <ValidationObserver v-slot="{ handleSubmit }">
        <form @submit.prevent="handleSubmit(submit)">
          <div class="form-group my-4">
            <label for="name">Name<Astrik /></label>
            <input
              type="text"
              disabled
              v-model="name"
              class="form-control"
              id="name"
            />
          </div>

          <ValidationProvider
            name="assigned_permissions"
            rules=""
            v-slot="{ errors }"
          >
            <div class="form-group my-4">
              <label for="assigned_permissions">Permissions</label>
              <table class="table">
                <thead>
                  <tr>
                    <th>Name</th>
                    <th>Description</th>
                    <th>Assign</th>
                  </tr>
                </thead>
                <tbody>
                  <tr class="col-md-4" v-for="p in all_permissions" :key="p.id">
                    <td>{{ p.name }}</td>
                    <td>{{ p.description }}</td>
                    <td>
                      <input
                        type="checkbox"
                        v-model="assigned_permissions"
                        :value="p.id"
                      />
                    </td>
                  </tr>
                </tbody>
              </table>
              <span>{{ errors[0] }}</span>
            </div>
          </ValidationProvider>
          <div class="button-form-group">
            <button type="submit" class="btn btn-success">Assign</button>
            <router-link
              class="text-decoration-none btn btn-danger pull-right"
              :to="{
                name: 'RoleList',
              }"
              >Cancel
            </router-link>
          </div>
        </form>
      </ValidationObserver>
    </div>
  </div>
</template>

<script>
export default {
  name: "AssignPermissionToRole",
  data() {
    return {
      submitting: false,
      all_permissions: [],
      assigned_permissions: [],
      role: null,
      name: "",
    };
  },
  mounted() {
    // if (this.can("assign-permission-to-role")) {
    this.getRoleWithPermissions();
    // } else {
    //   this.$router.push({
    //     name: "Dashboard",
    //   });
    // }
  },
  methods: {
    getRoleWithPermissions() {
      this.submitting = true;
      this.$http
        .get("role/" + this.$route.params.id + "/with-permissions")
        .then((res) => {
          if (res.data.status == 1) {
            this.role = res.data.data.role;
            this.all_permissions = res.data.data.all_permissions;
            this.assigned_permissions = res.data.data.assigned_permissions;
            this.name = this.role.name;
          } else {
            this.$notify({
              group: "notifications",
              title: res.data.message,
              type: "error",
              text: res.data.errors[0],
            });
          }
        })
        .catch((err) => {
          console.log(err);
        })
        .finally(() => {
          this.submitting = false;
        });
    },
    submit() {
      this.submitting = true;
      this.$http
        .post("role/assign-permission/" + this.$route.params.id, {
          permissions: this.assigned_permissions,
        })
        .then((res) => {
          if (res.data.status == 1) {
            this.getRoleWithPermissions();
          } else {
            this.$notify({
              group: "notifications",
              title: res.data.message,
              type: "error",
              text: res.data.errors[0],
            });
          }
        })
        .catch((err) => {
          console.log(err);
        })
        .finally(() => {
          this.submitting = false;
        });
    },
  },
};
</script>
